import { Typography } from "@mui/material";

import HNSColors from "../../../../../ui library/HNSColors";
import STRINGS from "../../utils/strings";

export default function EmptyTimeWindow() {
  return (
    <div
      className="flex flex-col items-center justify-center gap-1 rounded-[8px] p-6"
      style={{ backgroundColor: HNSColors.tertiary[900] }}
    >
      <Typography className="text-center text-xl text-blue-700 font-semibold">
        {STRINGS.NO_TIME_WINDOW}
      </Typography>
      <Typography className="text-center">
        {STRINGS.ADD_TIME_SLOT}
      </Typography>
    </div>
  );
}
